import { EField } from "./schema.indexContractBulkIndex.types";
export var getInitialValues = function (_a) {
    var _b;
    var defaultGenerateLetter = _a.defaultGenerateLetter, letterTemplates = _a.letterTemplates, property = _a.property;
    return (_b = {},
        _b[EField.GenerateLetter] = defaultGenerateLetter,
        _b[EField.LetterType] = letterTemplates === null || letterTemplates === void 0 ? void 0 : letterTemplates[0].id,
        _b);
};
